import { Injectable } from '@angular/core';
import { CountryEnum } from '../../model/countryEnum';
import { SessionBusiness } from '../sessionBusiness.service';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MenuConfig {
    get isDevelopment(): Boolean {
        return !environment.production;
    }

    constructor(private sessionBusiness: SessionBusiness) {}

    public defaults: any = {
        aside: {
            self: {},
            items: [
                {
                    title: 'Voltar para o menu anterior',
                    translate: 'MENU.BACKPREVIOUSMENU',
                    root: true,
                    icon: 'flaticon-reply',
                    page: '/Afs',
                    bullet: 'dot',
                    permission: this.AddPermission([CountryEnum.All]),
                },
                {
                    section: 'Contas a Receber',
                    translate: 'MENU.ACCOUNTRECEIVING',
                    permission: this.AddPermission([CountryEnum.Brasil]),
                },
                {
                    title: 'Arquivos de Retorno',
                    root: true,
                    bullet: 'dot',
                    icon: 'flaticon-folder-2',
                    translate: 'MENU.FILERETURN',
                    permission: this.AddPermission([CountryEnum.Brasil]),
                    submenu: [
                        {
                            title: 'Gerenciar',
                            bullet: 'dot',
                            page: '/fileReturn/file-manage',
                            translate: 'MENU.MANAGE',
                            permission: this.AddPermission([CountryEnum.Brasil]),
                        },
                        {
                            title: 'Importar',
                            bullet: 'dot',
                            page: '/fileReturn/file-import',
                            translate: 'MENU.IMPORT',
                            permission: this.AddPermission([CountryEnum.Brasil]),
                        },
                    ],
                },
                // {
                //     title: 'Arquivos de Cobradoras',
                //     root: true,
                //     bullet: 'dot',
                //     icon: 'flaticon-price-tag',
                //     translate: 'MENU.COLLECTORFILE',
                //     permission: this.AddPermission([CountryEnum.Brasil]),
                //     submenu: [
                //         {
                //             title: 'Gerenciar',
                //             bullet: 'dot',
                //             page: '/collector-file/collector-file-manage',
                //             translate: 'MENU.MANAGE',
                //             permission: this.AddPermission([CountryEnum.Brasil]),
                //         },
                //         {
                //             title: 'Importar',
                //             bullet: 'dot',
                //             page: '/collector-file/collector-file-import',
                //             translate: 'MENU.IMPORT',
                //             permission: this.AddPermission([CountryEnum.Brasil]),
                //         },
                //     ],
                // },
                {
                    title: 'Caixa',
                    root: true,
                    bullet: 'dot',
                    icon: 'flaticon2-cube',
                    translate: 'MENU.CASHIER',
                    permission: this.AddPermission([CountryEnum.All]),
                    submenu: [
                        {
                            title: 'Gerenciar',
                            bullet: 'dot',
                            page: '/cashier/management',
                            translate: 'MENU.MANAGE',
                            permission: this.AddPermission([CountryEnum.All]),
                        },
                    ],
                },
                // US 648747 - Oculta a visualização do histórico PIX (Recebimento Pix).
                // Clientes passaram a usar apenas a tela de sincronização PIX.
                // {
                //     title: 'Recebimentos',
                //     root: true,
                //     bullet: 'dot',
                //     icon: 'fa fa-chevron-circle-down',
                //     translate: 'MENU.RECEIVINGS',
                //     permission: this.AddPermission([CountryEnum.Brasil]),
                //     submenu: [
                //         {
                //             title: 'Recebimento Pix',
                //             bullet: 'dot',
                //             page: '/receiving/pix-results',
                //             translate: 'MENU.PIX',
                //             permission: this.AddPermission([CountryEnum.Brasil]),
                //         },
                //     ],
                // },
                {
                    title: 'Relatório',
                    root: true,
                    bullet: 'dot',
                    icon: 'flaticon-list-2',
                    translate: 'MENU.REPORT',
                    permission: this.AddPermission([CountryEnum.Paraguay]),
                    submenu: [
                        {
                            title: 'Facturación',
                            bullet: 'dot',
                            page: '/report/py/facturation',
                            translate: 'MENU.FATURATION',
                            permission: this.AddPermission([CountryEnum.Paraguay]),
                        },
                    ],
                },
                {
                    title: 'Boleto',
                    root: true,
                    bullet: 'dot',
                    icon: 'flaticon2-document',
                    translate: 'MENU.BILLET',
                    permission: this.AddPermission([CountryEnum.Brasil]),
                    submenu: [
                        {
                            title: 'Data de Vencimento em Lotes',
                            bullet: 'dot',
                            page: '/billet/due-date-in-batches',
                            translate: 'MENU.DUE_DATE_IN_BATCHES',
                            permission: this.AddPermission([CountryEnum.Brasil]),
                        },
                    ],
                },
                {
                    title: 'Arquivos de Remessa',
                    root: true,
                    bullet: 'dot',
                    icon: 'flaticon-folder-3',
                    translate: 'MENU.FILEREMITANCE',
                    permission: this.AddPermission([CountryEnum.Brasil]),
                    submenu: [
                        {
                            title: 'Gerenciar',
                            bullet: 'dot',
                            page: '/fileRemitance/management',
                            translate: 'MENU.MANAGE',
                            permission: this.AddPermission([CountryEnum.Brasil]),
                        },
                        {
                            title: 'Gerar Arquivo',
                            bullet: 'dot',
                            page: '/fileRemitance/generate',
                            translate: 'MENU.FILEGENERATE',
                            permission: this.AddPermission([CountryEnum.Brasil]),
                        },
                    ],
                },
                {
                    title: 'Cartão Recorrente',
                    root: true,
                    bullet: 'dot',
                    icon: 'flaticon-coins',
                    translate: 'MENU.RECURRINGCARD',
                    permission: this.AddPermission([CountryEnum.Brasil]),
                    submenu: [
                        {
                            title: 'Recorrências Cartão de Credito',
                            bullet: 'dot',
                            page: '/recurring-card/records',
                            translate: 'MENU.CREDITCARDRECURRENCE',
                            permission: this.AddPermission([CountryEnum.Brasil]),
                        },
                        {
                            title: 'Gerenciamento de Recorrência',
                            bullet: 'dot',
                            page: '/recurring-card/management',
                            translate: 'MENU.RECURRENCEMANAGEMENT',
                            permission: this.AddPermission([CountryEnum.Brasil]),
                        },
                    ],
                },
                {
                    title: 'Débito Automático',
                    root: true,
                    bullet: 'dot',
                    icon: 'flaticon-file-2',
                    permission: this.AddPermission([CountryEnum.Brasil]),
                    submenu: [
                        {
                            title: 'Remessa',
                            bullet: 'dot',
                            page: '/automatic-debit/rem',
                            permission: this.AddPermission([CountryEnum.Brasil]),
                        },
                        {
                            title: 'Retorno',
                            bullet: 'dot',
                            page: '/automatic-debit/ret',
                            permission: this.AddPermission([CountryEnum.Brasil]),
                        },
                    ],
                },
                {
                    title: 'Acerto Cobradora',
                    root: true,
                    bullet: 'dot',
                    icon: 'flaticon-interface-5',
                    permission: this.AddPermission([CountryEnum.Brasil]),
                    submenu: [
                        {
                            title: 'Gerenciar Acertos',
                            bullet: 'dot',
                            page: '/agreement-external-collector/manage-agreement',
                            permission: this.AddPermission([CountryEnum.Brasil]),
                        },
                        {
                            title: 'Criar Acerto',
                            bullet: 'dot',
                            page: '/agreement-external-collector/new',
                            permission: this.AddPermission([CountryEnum.Brasil]),
                        },
                    ],
                },
                {
                    section: 'Contábil',
                    translate: 'MENU.ACCOUNTING',
                    permission: this.AddPermission([CountryEnum.Brasil]),
                },
                {
                    title: 'Lote Contábil',
                    root: true,
                    bullet: 'dot',
                    icon: 'flaticon-list-1',
                    translate: 'MENU.ACCOUNTING_BATCH',
                    permission: this.AddPermission([CountryEnum.All]),
                    submenu: [
                        {
                            title: 'Gerenciar',
                            translate: 'MENU.MANAGE',
                            bullet: 'dot',
                            page: '/accounting/batch',
                            permission: this.AddPermission([CountryEnum.All]),
                        },
                    ],
                },
                {
                    section: 'Administrativo',
                    translate: 'MENU.MANAGEMENT',
                    permission: this.AddPermission([CountryEnum.Brasil]),
                },
                {
                    title: 'MENU.MANAGETASKS',
                    root: true,
                    bullet: 'dot',
                    icon: 'flaticon-list-1',
                    translate: 'MENU.MANAGETASKS',
                    page: '/tasks/manage-tasks',
                    permission: this.AddPermission([CountryEnum.Brasil]),
                },
                {
                    title: 'Gerenciar Erros',
                    root: true,
                    bullet: 'dot',
                    icon: 'flaticon-settings-1',
                    translate: 'MENU.MANAGEBUGS',
                    page: '/bugs/manage-bugs',
                    permission: this.AddPermission([CountryEnum.Brasil]),
                },
                {
                    title: 'MENU.MappingCurrentAccountBillet',
                    root: true,
                    bullet: 'dot',
                    icon: 'flaticon-list-2',
                    translate: 'MENU.MappingCurrentAccountBillet',
                    page: '/manager/mappingBillets',
                    permission: this.AddPermission([CountryEnum.All]),
                },
            ],
        },
    };

    public get configs(): any {
        return this.defaults;
    }

    private AddPermission(permissionTo: CountryEnum[]): boolean {
        if (permissionTo.some((item) => item == 0)) {
            return true;
        }
        return permissionTo.some((item) => item == this.sessionBusiness.CountryIdContext);
    }
}
